import MaskFemaleIcon from './MaskFemaleIcon'

export default MaskFemaleIcon
